import { prefix } from './actions';

export const options = state => state[prefix].options;
